export default __webpack_public_path__ + "c1125446986cf8543305f425db146f1a.svg";